var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPro5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.5,
    height: 45.574,
    viewBox: "0 0 64.5 45.574",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Komponente_10_45",
    "data-name": "Komponente 10 \\u2013 45",
    transform: "translate(0.25 0.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mortarboard",
    transform: "translate(0 -75.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46845",
    "data-name": "Pfad 46845",
    d: "M62.64,87.853,36.673,76.837a12.027,12.027,0,0,0-9.346,0L1.36,87.853a2.231,2.231,0,0,0,0,4.108l12.661,5.371v13.846a2.947,2.947,0,0,0-2.005,2.788v6.015a.938.938,0,0,0,.938.938h4.01a.938.938,0,0,0,.938-.937v-6.015a2.947,2.947,0,0,0-2.005-2.788V98.128l11.432,4.85a12.027,12.027,0,0,0,9.345,0L48.1,98.128v6.816c0,1.145-1.632,2.4-4.366,3.369A36.653,36.653,0,0,1,32,110.022a34.742,34.742,0,0,1-12.674-2.068.937.937,0,1,0-.724,1.729A36.635,36.635,0,0,0,32,111.9c8.716,0,17.979-2.437,17.979-6.952V97.332l1.434-.608A.937.937,0,1,0,50.681,95l-14.74,6.253a10.142,10.142,0,0,1-7.881,0l-10.41-4.417L29.3,92.067a4.75,4.75,0,0,0,2.7.782c2.212,0,3.945-1.292,3.945-2.942S34.212,86.965,32,86.965s-3.945,1.292-3.945,2.943a2.311,2.311,0,0,0,.081.609L15.219,95.8,2.092,90.235a.356.356,0,0,1,0-.656L28.06,78.563a10.142,10.142,0,0,1,7.881,0L61.908,89.579a.357.357,0,0,1,0,.656L54.691,93.3a.937.937,0,1,0,.732,1.726l7.217-3.062a2.231,2.231,0,0,0,0-4.108ZM32,88.84c1.264,0,2.07.632,2.07,1.067s-.806,1.067-2.07,1.067-2.07-.632-2.07-1.067S30.737,88.84,32,88.84Zm-15.974,30.2H13.891v-5.077a1.068,1.068,0,0,1,2.135,0v5.077Z",
    transform: "translate(0)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro5);
export default __webpack_public_path__ + "static/media/Pro5.556580727af87ac070466a66e1bcc56c.svg";
export { ForwardRef as ReactComponent };